import type { ExtensionConfig } from '@goto/shell'
import { getLaunchDarklyFlag } from '../helpers/shell-helpers'
import { LaunchDarklyVariations } from '../models/feature-flag.models'
import { getOOSArtifactUrl } from '../helpers/experience-helpers'

const extensionConfig: ExtensionConfig = {
  id: '@goto/oos-meeting-background-service',
  get url() {
    const version = getLaunchDarklyFlag(LaunchDarklyVariations.OOS_MEETING_BG_SERVICE_VERSION)
    return new URL(getOOSArtifactUrl('meeting-background-service-extension', version))
  },
}

export default extensionConfig
